<template>
  <b-modal
    id="scoutScreen"
    ref="scoutScreen"
    size="xl"
    hide-header
    @hide="hideModal"
  >
    <IndividualContact2
      ref="individualContact"
      :applicant_id="applicant_id"
      :applicantIndex="index"
      @changeIndex="changeIndex"
    />
    <template v-slot:modal-footer>
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="space" style="width: 300px;"></div>
        <div class="profile-toggle-container">
          <button
            class="btn btn-arw btn-plain"
            v-if="!(currentPage === 1 && index === 0)"
            @click="previous"
            style="margin-right: 5px;min-width: 40px;"
          >
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
          </button>
          <button
            class="btn btn-arw btn-plain"
            v-if="rowNumber !== applicantsCount.total"
            style="min-width: 40px;"
            @click="next"
          >
            <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>

        <div class="profile-close-button" @click="hideModal">
          &times;
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import IndividualContact2 from './IndividualContact2.vue';
import { mapGetters, mapMutations, mapState } from 'vuex';
export default {
  name: 'IndividualContactModal',
  props: ['applicant_id', 'applicantIndex'],
  components: { IndividualContact2 },
  data() {
    return {
      index: this.applicantIndex,
      applicantId: this.applicant_id,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      applicantsCount: 'getApplicantCounts',
      currentPage: 'getPage',
      getFirstProfileModalOpen: 'getFirstProfileModalOpen',
      getLastProfileModalOpen: 'getLastProfileModalOpen',
    }),
    ...mapState({
      applicants: ({ applicant }) => applicant.applicants,
      currentPageApplicants: ({ applicant }) => applicant.currentPageApplicants,
    }),
    rowNumber() {
      return this.index + 1 + (this.currentPage - 1) * 15;
    },
  },
  methods: {
    ...mapMutations({
      setPage: 'setPage',
      setReloadApplicants: 'setReloadApplicants',
    }),
    hideModal() {
      this.$refs.scoutScreen.hide();
      if (this.currentPageApplicants.length !== this.applicants.length) {
        this.setReloadApplicants(true);
      }
    },
    cancel() {
      this.openMessageComposeForm = false;
      this.showReplyForm = false;
      // this.selectedMessageId = null;
    },
    changeApplicant(index) {
      this.applicantId = this.applicants[index].id;
      this.index = index;
      this.applicantJd = this.currentApplicantJd;
      //   this.isFavorited = this.applicants[index].isFavorite;
      //   this.isInterviewed = this.applicants[index].isInterview;
    },
    changeIndex(index) {
      this.index = index;
    },
    previous() {
      this.$refs.individualContact.previous();
    },
    next() {
      this.$refs.individualContact.next();
    },

    show() {
      this.$refs.scoutScreen.show();
    },
  },
  mounted() {
    this.show();
  },
  watch: {
    applicantIndex(value) {
      this.index = value;
    },
  },
};
</script>

<style scoped>
.fa-chevron-right,
.fa-chevron-left {
  font-size: 1.5rem !important;
}
:deep(.modal-footer) {
  justify-content: space-between;
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  background: #fff;
  position: sticky;
  bottom: 0;
  z-index: 1000;
}

>>> .modal-xl {
  max-width: 90vw !important;
}

>>> .modal-body {
  padding: 0px !important;
  overflow: hidden;
  min-height: calc(90vh - 120px); /* Subtract footer height and margins */
  display: flex;
  flex-direction: column;
}
.modal-content-wrapper {
  flex: 1;
  min-height: 500px; /* Minimum height to prevent footer jumping */
  display: flex;
  flex-direction: column;
}

.btn-cancel {
  border-color: #3c3c3c;
  color: #3c3c3c;
  border-radius: 4px;
}
</style>
